import { render, staticRenderFns } from "./DialogCategoriaNivelFamilia.vue?vue&type=template&id=0c34ba8f"
import script from "./DialogCategoriaNivelFamilia.vue?vue&type=script&lang=js"
export * from "./DialogCategoriaNivelFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports